import { connect } from 'react-redux'
import { Dispatch } from 'redux';
import RouterUI from './RouterUI';
import { RouterDispatch, RouterUIState } from './model';
import { ActionType } from '../../Actions/ActionTypes';
import ApplicationState from '../../../../../../../ApplicationState';
import IDispatcher from '../../../../../../Util/IDispatcher';
import IState from '../../../../../../Util/IState';


const mapStateToProps = (state: ApplicationState): IState<RouterUIState> => {
    return {
        state: {
            router: state.router,
            home: state.home
        }
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<RouterDispatch> => ({
    dispatcher: {
        urlChanged: () => { dispatch({ type: ActionType.URL_CHANGED }) }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(RouterUI)